// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Full-Width Fixed Header Navigation
   ========================================== */

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(11, 15, 23, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 1rem 0;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.navbar.scrolled {
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  border-bottom-color: rgba(255, 255, 255, 0.12);
  padding: 0.75rem 0;
}

.nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: translateY(-1px);
}

.navbar .nav-links {
  display: flex;
  align-items: center;
}

.navbar .nav-links ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 1.5rem;
  align-items: center;
}

.navbar .nav-link {
  text-decoration: none;
  color: var(--text-muted);
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  border-radius: var(--radius-pill);
}

.navbar .nav-link:hover {
  color: #ffffff;
  background: rgba(245, 158, 11, 0.12);
  box-shadow: inset 0 0 0 1px rgba(245, 158, 11, 0.3);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-btn-primary {
  background: var(--grad-primary);
  color: #0F172A;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.6rem 1.4rem;
  border-radius: var(--radius-pill);
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.2;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.nav-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
  color: #000000;
}

.navbar .mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1002;
}

.navbar .mobile-menu-btn span {
  width: 100%;
  height: 2px;
  background: #ffffff;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.navbar .mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
  background: var(--color-amber);
}

.navbar .mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.navbar .mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
  background: var(--color-orange);
}

.mobile-menu {
  display: none;
  flex-direction: column;
  background: var(--bg-deep-space);
  backdrop-filter: blur(20px);
  padding: 6rem 2rem 2rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
}

.mobile-menu.active {
  display: flex;
}

.mobile-menu .mobile-nav-link {
  padding: 1.25rem 0;
  text-decoration: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 1.25rem;
  border-bottom: 1px solid var(--border-bento);
  transition: color 0.3s ease;
}

.mobile-menu .mobile-nav-link:hover {
  color: var(--color-amber);
}

.mobile-menu .mobile-actions {
  margin-top: 2rem;
}

@media (max-width: 900px) {
  .navbar .nav-links,
  .nav-actions {
    display: none;
  }
  .navbar .mobile-menu-btn {
    display: flex;
  }
  .nav-container {
    padding: 0 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Navbar.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Full-Width Fixed Header Navigation\n   ========================================== */\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background: rgba(11, 15, 23, 0.88);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 1rem 0;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 1000;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n}\n\n.navbar.scrolled {\n  background: rgba(15, 23, 42, 0.96);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);\n  border-bottom-color: rgba(255, 255, 255, 0.12);\n  padding: 0.75rem 0;\n}\n\n.nav-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: transform 0.3s ease;\n}\n\n.logo:hover {\n  transform: translateY(-1px);\n}\n\n.navbar .nav-links {\n  display: flex;\n  align-items: center;\n}\n\n.navbar .nav-links ul {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.navbar .nav-link {\n  text-decoration: none;\n  color: var(--text-muted);\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 0.5rem 1rem;\n  transition: all 0.3s ease;\n  border-radius: var(--radius-pill);\n}\n\n.navbar .nav-link:hover {\n  color: #ffffff;\n  background: rgba(245, 158, 11, 0.12);\n  box-shadow: inset 0 0 0 1px rgba(245, 158, 11, 0.3);\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.nav-btn-primary {\n  background: var(--grad-primary);\n  color: #0F172A;\n  font-weight: 700;\n  font-size: 0.9rem;\n  padding: 0.6rem 1.4rem;\n  border-radius: var(--radius-pill);\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.2;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);\n  color: #000000;\n}\n\n.navbar .mobile-menu-btn {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 26px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1002;\n}\n\n.navbar .mobile-menu-btn span {\n  width: 100%;\n  height: 2px;\n  background: #ffffff;\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n.navbar .mobile-menu-btn.active span:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n  background: var(--color-amber);\n}\n\n.navbar .mobile-menu-btn.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.navbar .mobile-menu-btn.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n  background: var(--color-orange);\n}\n\n.mobile-menu {\n  display: none;\n  flex-direction: column;\n  background: var(--bg-deep-space);\n  backdrop-filter: blur(20px);\n  padding: 6rem 2rem 2rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 999;\n}\n\n.mobile-menu.active {\n  display: flex;\n}\n\n.mobile-menu .mobile-nav-link {\n  padding: 1.25rem 0;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 1.25rem;\n  border-bottom: 1px solid var(--border-bento);\n  transition: color 0.3s ease;\n}\n\n.mobile-menu .mobile-nav-link:hover {\n  color: var(--color-amber);\n}\n\n.mobile-menu .mobile-actions {\n  margin-top: 2rem;\n}\n\n@media (max-width: 900px) {\n  .navbar .nav-links,\n  .nav-actions {\n    display: none;\n  }\n  .navbar .mobile-menu-btn {\n    display: flex;\n  }\n  .nav-container {\n    padding: 0 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
